export default {
  nav: {
    portfolio: "Portfolio de Widyo",
    whyme: "Pourquoi moi?",
    education: "Éducation",
    experience: "Expérience",
    organizational: "Organisation",
    events: "Événements",
    portfolio_link: "Portfolio",
    skills: "Compétences",
    certificates: "Certificats",
    awards: "Récompenses",
    contact: "Contact",
    downloadResume: "Télécharger le CV",
    downloadPortfolio: "Télécharger le Portfolio",
    letsConnect: "Connectons-nous",
  },
  hero: {
    greeting: "Bonjour!",
    name: "Je suis Widyo Tri Cahya Utomo",
    nickname: "Dio",
    title: "Ingénieur DevOps | Ingénieur de données",
    description: "Ingénieur DevOps à l'Apple Developer Institute, automatisant l'infrastructure AWS as code avec Terraform et Ansible et construisant des pipelines CI/CD. Fort de trois ans d'ingénierie de données d'entreprise — ETL/CDC, migrations cloud et plateformes de données.",
    downloadResume: "Télécharger le CV",
    contactMe: "Contactez-moi",
  },
  whyme: {
    title: "Pourquoi moi?",
    subtitle: "Ce qui me rend différent en tant qu'ingénieur DevOps",
    content: "Je ne fais pas que déplacer des données — je les transforme en intelligence qui crée une réelle valeur commerciale. J'aborde chaque problème avec un scepticisme curieux, validant les hypothèses et concevant des systèmes qui évoluent, restent fiables et produisent réellement des résultats. Mon expérience couvre l'ingénierie de données de bout en bout, y compris l'ingestion, l'entreposage, l'orchestration, la gouvernance et le réglage des performances sur des piles modernes. J'ai travaillé dans des environnements d'entreprise où l'échec n'est pas une option, donc la fiabilité, la sécurité et la précision ne sont pas négociables. Je suis obsédé par une architecture propre, des pipelines efficaces et une automatisation qui prévient les maux de tête — ne les cause pas. Avec plus de 40 certifications industrielles et une concentration tournée vers l'avenir sur l'IA et le Web3, je construis des systèmes conçus pour les exigences d'aujourd'hui et l'innovation de demain. En bref, je fournis des solutions de données conçues pour l'impact, l'échelle et l'avenir.",
  },
  tools: {
    title: "Voici quelques-uns des outils et technologies que j'utilise quotidiennement",
  },
  education: {
    title: "Éducation",
    subtitle: "Fondation académique en ingénierie informatique avec un accent fort sur les systèmes de données",
    graduated: "Diplômé",
    institutions: {
      maranatha: {
        name: "Université Chrétienne Maranatha",
        degree: "Licence en Ingénierie (B.E.), Génie Informatique",
        highlights: [
          "GPA: 3.83",
          "Cours pertinents: Bases de données, Systèmes d'exploitation, Réseaux informatiques",
        ],
      },
      yosuka: {
        name: "Lycée Yos Sudarso - Karawang",
        degree: "Spécialité Mathématiques et Sciences",
        status: "Diplôme d'études secondaires",
      },
      akademicrypto: {
        name: "Akademi Crypto - Tangerang",
        degree: "Programme sans diplôme en Web3 et Blockchain",
        status: "Mar 2024 - Aujourd'hui",
        highlights: [
          "Focus sur Web3, les fondamentaux de la Blockchain et les technologies décentralisées",
          "Apprentissage actif en crypto-économie, contrats intelligents et écosystèmes DeFi",
        ],
      },
      tradewithsuli: {
        name: "TradeWithSuli - Jakarta",
        degree: "Programme sans diplôme en Trading Financier et Analyse de Marché",
        status: "Sep 2025 - Aujourd'hui",
        highlights: [
          "Focus sur le trading de cryptomonnaies utilisant l'analyse fondamentale et technique",
          "Développement de stratégies de trading pratiques et de compétences d'évaluation de marché par l'apprentissage communautaire",
        ],
      },
    },
  },
  experience: {
    title: "Expérience",
    subtitle: "Automatisation de l'infrastructure cloud, ainsi qu'ingénierie de données d'entreprise et conseil technique dans diverses industries",
  },
  organizational: {
    title: "Organisation & Communauté",
    subtitle: "Rôles de leadership et participation active dans les organisations professionnelles et communautaires",
    activities: [
      {
        title: "Leadership Universitaire",
        organization: "Université Chrétienne Maranatha",
        role: "Chef du Laboratoire Informatique Digital",
        dates: "Avr 2021 – Avr 2023",
        description: "A dirigé le laboratoire, géré des projets et le mentorat d'étudiants.",
      },
      {
        title: "Communautés Crypto",
        organization: "Akademi Crypto, TradeWithSuli, Coin Kami",
        role: "Membre Actif",
        dates: "Fév 2023 - Aujourd'hui",
        description: "Participant actif et apprenant tout au long de la vie dans les communautés Web3 et crypto.",
      },
      {
        title: "Connect Group et Ministère Multimédia",
        organization: "Église Rose of Sharon",
        role: "Membre Actif",
        dates: "Août 2015 - Aujourd'hui",
        description: "Activement impliqué dans la communauté de l'église à travers la communion Connect Group et le service dans le Ministère Multimédia, soutenant les services de culte et la production médiatique créative.",
      },
    ],
  },
  events: {
    title: "Événements & Galerie",
    subtitle: "Photos et moments forts d'événements, de conférences, séminaires et d'activités professionnelles",
    noImages: "Aucune image disponible",
    maintenance: "En Maintenance",
    maintenanceDesc: "Cette section est actuellement mise à jour avec du nouveau contenu. Revenez bientôt !",
  },
  portfolio: {
    title: "Portfolio",
    subtitle: "Projets sélectionnés présentant le développement web et le travail d'ingénierie de données",
    webPortfolioTitle: "Portfolio Web",
    dataPortfolioTitle: "Portfolio d'Ingénierie de Données",
    viewLive: "Voir en direct",
    explore: "Explorer",
    showMore: "Afficher Plus",
    showLess: "Afficher Moins",
    downloadPdf: "Télécharger le Portfolio en PDF",
    generatingPdf: "Génération du PDF...",
    selectProjects: "Sélectionner les projets",
    selectAll: "Tout sélectionner",
    cancel: "Annuler",
    downloadSelected: "Télécharger",
    webProjects: [
      {
        title: "Site Web Maju Cipta Karya",
        description: "Maju Mapan est une marque de meubles moderne qui allie design élégant et durabilité. Chaque pièce est fabriquée à la main par des artisans locaux utilisant des matériaux écologiques - apportant confort, équilibre et chaleur dans chaque espace de vie.",
      },
      {
        title: "Site Web Tcuber Store",
        description: "Tcuber Store est une plateforme de recharge de jeux en ligne de confiance en Indonésie, fournissant des crédits numériques rapides, sécurisés et abordables pour les jeux populaires comme Mobile Legends, Free Fire, Roblox, Genshin Impact, Clash of Clans et PUBG Mobile. Nous offrons diverses méthodes de paiement et un support réactif pour garantir une expérience de jeu fluide.",
      },
    ],
    dataProjects: [
      {
        title: "Analyse de données de manchots avec IA",
        description: "Outil d'exploration de données interactif alimenté par l'IA. Analysez les données d'espèces de manchots avec des questions en langage naturel et visualisez les insights à travers des graphiques dynamiques. Construit avec React, Recharts et Lovable AI.",
      },
    ],
    penguinExplorer: {
      title: "Poser des questions sur les manchots",
      selectQuestion: "Que souhaitez-vous savoir ?",
      submit: "Soumettre",
      analyzing: "Analyse en cours...",
      thinking: "Réflexion...",
      errorLoading: "Erreur lors du chargement des données de manchots",
      errorAnalyzing: "Erreur lors de l'analyse des données",
      rateLimitError: "Limite de débit dépassée. Veuillez réessayer plus tard.",
      paymentError: "Paiement requis. Veuillez ajouter des crédits à votre espace de travail Lovable AI.",
      speciesDistribution: "Distribution des espèces",
      billVsBody: "Longueur du bec vs masse corporelle",
      dataTable: "Aperçu des données",
      questions: [
        "Quels manchots ont le bec le plus long ?",
        "Où vivent les manchots les plus lourds ?",
        "Quels manchots ont les nageoires les plus courtes ?",
      ],
    },
  },
  skills: {
    title: "Compétences",
    subtitle: "Infrastructure cloud, automatisation et CI/CD, sur une base d'ingénierie de données d'entreprise",
    categories: {
      cloud: "Cloud et infrastructure",
      iac: "IaC et GitOps",
      cicd: "CI/CD",
      containers: "Conteneurs et observabilité",
      security: "Sécurité et réseaux",
      databases: "Bases de données",
      etl: "ETL et intégration",
      programming: "Programmation",
      soft: "Compétences humaines",
    },
  },
  certificates: {
    title: "Certificats Dataiku",
    subtitle: "Certifications professionnelles en science des données, apprentissage automatique et IA de Dataiku",
    clickToView: "Cliquez pour voir le certificat complet",
    download: "Télécharger",
    verify: "Vérifier",
    preview: "Aperçu du certificat",
  },
  awards: {
    title: "Récompenses & Certifications",
    subtitle: "Certifications professionnelles sur les plateformes de données, l'infrastructure cloud et les technologies AI",
    view: "Voir",
  },
  contact: {
    title: "Contactez-nous",
    subtitle: "Ouvert aux opportunités, collaborations et demandes de conférences",
    info: "Informations de contact",
    email: "E-mail",
    phone: "Téléphone",
    social: "Médias sociaux",
    sendMessage: "Envoyer un message",
    name: "Nom",
    namePlaceholder: "Masukkan nama",
    emailPlaceholder: "Masukkan email",
    message: "Message",
    messagePlaceholder: "Masukkan pesan",
    send: "Envoyer un message",
    copyright: "© 2025 Widyo Tri Cahya Utomo. Tous droits réservés.",
  },
  whatsapp: {
    title: "Contactez-nous",
    subtitle: "Choisissez comment vous souhaitez nous contacter",
    chatbot: "Discuter avec l'assistant IA",
    whatsapp: "Message sur WhatsApp",
    defaultMessage: "Bonjour Widyo ! J'aimerais entrer en contact avec vous.",
  },
  chatbot: {
    title: "Assistant IA",
    welcome: "Bonjour ! Je suis l'assistant IA de Widyo. Je peux répondre aux questions sur son expérience, ses compétences et ses projets. Comment puis-je vous aider ?",
    placeholder: "Tapez votre message...",
    error: "Désolé, une erreur s'est produite. Veuillez réessayer.",
  },
};
